import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import loading from '../images/loading.gif';
import styles from '../styles/skillsmodal.module.css';
import CSS3 from '../images/skillsLogos/CSS3_logo.png';
import HTML5 from '../images/skillsLogos/HTML5_logo.png';
import Figma from '../images/skillsLogos/Figma_logo.webp';
import JavaScript from '../images/skillsLogos/JavaScript_logo.png';
import ReactJS from '../images/skillsLogos/React_logo.png';
import ThreeJS from '../images/skillsLogos/Threejs_logo.png';
import PostgreSQL from '../images/skillsLogos/Postgresql_logo.png';
import Linux from '../images/skillsLogos/linux_logo.png';
import AWS from '../images/skillsLogos/aws_logo.png';
import GitHub from '../images/skillsLogos/git_logo.png';
import NodeJS from '../images/skillsLogos/nodejs_logo.png';
import Python from '../images/skillsLogos/Python_logo.png';
import CPP from '../images/skillsLogos/CPP_Logo.png';
import Java from '../images/skillsLogos/Java_logo.png'

const images = {
    CSS3,
    HTML5,
    Figma,
    JavaScript,
    ReactJS,
    ThreeJS,
    PostgreSQL,
    Linux,
    AWS,
    GitHub,
    NodeJS,
    Python,
    CPP,
    Java
}

function ProjectBox({projectId, name, image, link, web}){
    console.log(web)
    return(
        <div 
            className={styles.projectBox}
            style={{
                backgroundImage: `url(${image})`,
                opacity: 1 // Ensuring no unwanted opacity here for the entire div
            }}
        >
            <p>{name}</p>
            <a href={`/projects?projectId=${projectId}&webProject=${web}`}>View Details</a>
            <a href={link}>View Project</a>
        </div>
    )
}

function ModalData(props){
    const [data, setData] = useState(null);
    const skill = props.skill.toLowerCase();

    useEffect(() => {
        axios.get(`/api/projects/skills/${skill}`)
            .then(response => {
                setData(response.data);
            })
            .catch(error => {
                console.error(`Error fetching ${skill} data`, error)
            })
    }, [skill])

    return(
        <div className={styles.resultsContainer}>
        {data ? (
                data.projects.length > 0 ? (
                    data.projects.map((project) => (
                        <ProjectBox 
                            key={project.id}
                            projectId={project.id}
                            name={project.project_name} 
                            image={project.images.homepage ? project.images.homepage : Object.values(project.images)[0]} 
                            link={project.link}
                            web={project.web_project}
                        />
                    ))
                ) : (
                    <p className={styles.messageText}>Projects Coming Soon</p>
                )
            ) : (
                <div className={styles.loading}><img src={loading} alt="loading_gif" /></div>
            )}
        </div>
    )
}

function Modal(props){

    const handleClose = () => {
        props.onStateChange({state: false, type: undefined});
    }

    return (
        <div className={styles.modal}>
            <div className={styles.contentContainer}>
                <div className={styles.logoContainer}>
                    <img className={styles.logo} src={images[props.type]} alt={props.type} />
                </div>
                <FontAwesomeIcon icon={faX} className={styles.closeIcon} onClick={handleClose} />
                <ModalData skill={props.type} />
            </div>
        </div>
    )
};
  
export { Modal };